import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Table, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";
import CustomTooltip from "utils/CustomTooltip";

export default function SEMRushSetup(props) {
  props.pageLocator();
  const route = useContext(RouterContext);
  const nextPage = getNextPage(props.onboarding_progress);
  const [showBoxes, setShowBoxes] = useState(false);
  const [validated, setValidation] = useState(false);
  const checkValidation = () => {
    const form = document.getElementById("onboarding-form");
    if (form.checkValidity() === true) {
      setValidation(true);
    } else {
      setValidation(false);
    }
  };

  let projectIdImg = require("images/semrush-project-id.jpg");
  projectIdImg = <img className="mt-2" src={`/datapulse${projectIdImg}`} />;
  const tooltipMessage = <div className="p-2">The ID can change if a new target location has been selected. To make sure the ID is correct, open the project in SEMRush, and in the 'Position Tracking' tile, select 'View full report'. Copy the ID from the URL.<br></br>{projectIdImg}</div>

  const addNewRow = () => {
    //create an object with all of the state fields
    let newRow = {};
    newRow.id = "";
    newRow.label = "";
    newRow.website = props.website;
    // setValidation(true);
    let accessChecked = props.teamAccess;
    accessChecked["SEMRush"]["Completed setup"] = "1";
    props.setTeamAccess({ ...accessChecked });
    props.setSemRushIds([...props.semRushIds, newRow]);
  };

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  const removeRow = (el) => {
    if (props.semRushIds.length == 1) {
      setValidation(false);
      let accessChecked = props.teamAccess;
      accessChecked["SEMRush"]["Completed setup"] = "0";
      props.setTeamAccess({ ...accessChecked });
    }
    props.setSemRushIds(props.semRushIds.filter((row, idx) => idx != el));
  };
  useEffect(() => {
    if (props.teamAccess["SEMRush"]["Completed setup"] !== "1" && showBoxes && props.semRushIds.length == 0) {
      setValidation(false);
    }
  });

  const setupBox = (el, idx) => {
    return (
      <div className="sem-box mr-2">
        <Row>
          <Col style={{ paddingTop: "15px" }}>
            <div className="table-responsive">
              <Table className="overflow-hidden">
                <tbody>
                  <tr>
                    <td>
                      <p className="f16 primary">ID:</p>
                    </td>
                    <td>
                      <Form.Control
                        required
                        size="sm"
                        style={{ width: "170px" }}
                        value={el.id}
                        onChange={(e) => {
                          let newArray = props.semRushIds;
                          newArray[idx].id = e.target.value;
                          props.setSemRushIds([...newArray]);
                          checkValidation();
                        }}
                        id={`ob-analytics-id`}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p className="f16 primary">Label:</p>
                    </td>
                    <td>
                      <Form.Control
                        value={el.label}
                        size="sm"
                        style={{ width: "266px" }}
                        onChange={(e) => {
                          let newArray = props.semRushIds;
                          newArray[idx].label = e.target.value;
                          props.setSemRushIds([...newArray]);
                        }}
                        id={`ob-semrush-label`}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
          <Col md={1}>{idx >= 0 && <i onClick={() => removeRow(idx)} className="fas fa-minus-circle color-danger"></i>}</Col>
        </Row>
      </div>
    );
  };
  return (
    <>
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">SEMRush Setup</p>
          </div>
          <div>
            <p className="f14 nunito-regular primary ">
              Now we will need to set up the client in SEMRush. Follow along with the tutorial video to set up the client in SEMRush under the {route.organization.name}
              account, and then add the project ID's in the field below. You can use the 'Label' field to name them for your own reference (this will not affect
              the data in any way).
            </p>
          </div>
        </Col>
      </Row>
      <Row className="mb-1 px-lg-4 px-0 justify-content-center">
        <Col md={4}>
          <div>
            <p className="f16 nunito-regular primary ">Do we need to set up SEMRush for this client?</p>
          </div>
        </Col>
      </Row>
      <Row className="mb-3 px-lg-4 px-4 pb-3 justify-content-center">
        <Col md={4}>
          <div className="d-flex flex-column ">
            <Form.Check
              className="f16"
              name="ob-tracking"
              custom
              label="Yes"
              type="radio"
              id="ob-tracking-yes"
              onClick={() => {
                setShowBoxes(true);
                setValidation(true);
                let accessChecked = props.teamAccess;
                accessChecked["SEMRush"]["Exist"] = "1";

                props.setTeamAccess({ ...accessChecked });
              }}
            />
            <Form.Check
              name="ob-tracking"
              className="f16"
              custom
              label="No"
              type="radio"
              id="ob-tracking-no"
              onClick={() => {
                setShowBoxes(false);
                setValidation(true);
                let accessChecked = props.teamAccess;
                accessChecked["SEMRush"]["Exist"] = "0";
                props.setTeamAccess({ ...accessChecked });
              }}
            />
          </div>
        </Col>
      </Row>
      <Row className={`justify-content-center ${!showBoxes && "d-none"}`}>
        <Col md={5}>
          <p className="visby-bold pb-2 light-primary f14 d-inline-block mr-2">
            Provide the information below:
          </p>
          <CustomTooltip
            faClass="far fa-question-circle f16 light-primary"
            message= {tooltipMessage}
            inline={true}
          />
        </Col>
      </Row>
      <Row className={`justify-content-center ${!showBoxes && "d-none"}`}>
        <Col className="mr-0" md={5}>
          <Button
            className="mt-1 mb-1 ml-0 btn-sm semrush-add-project"
            size="sm"
            as="input"
            type="button"
            onClick={() => addNewRow()}
            value="+ Add Project"
            variant="success"
          />
        </Col>
      </Row>
      <Row className={`mb-3  justify-content-center ${!showBoxes && "d-none"}`}>
        <Col className="mr-0" md={5}>
          <div className="sem-container">
            <div className="sem-row justify-content-center">
              {props.semRushIds.map((row, idx) => {
                return <div key={idx}>{setupBox(row, idx)}</div>;
              })}
            </div>
          </div>
        </Col>
      </Row>
      {(!props.savedSemrushKey || props.savedSemrushKey == "") &&
        <Row className={`mb-5  justify-content-center ${!showBoxes && "d-none"}`}>
          <Col md={5}>
            <p className="visby-bold pb-2 light-primary f14">SEMRush API Key:</p>
            <Form.Control
              required
              placeholder="Enter SEMRush API Key"
              value={props.semrushApiKey ? props.semrushApiKey : ""}
              disabled={props.savedSemrushKey.length > 4}
              onChange={(e) => {props.setSemrushApiKey(e.target.value);  checkValidation()}}
              name="semrush_api_key"
            />
          </Col>
        </Row>
      }
      <Row>
        <Col>
          <div className="navButtonRow">
            <BackButton routes={props.routes} />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
